/* ==========================================================
   ps-transitions.js
   Performative Shirts — Product transition + size selector

   Loaded in layout/theme.liquid before </body> via:
     <script src="{{ 'ps-transitions.js' | asset_url }}" defer></script>
   ========================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------
     1. FLIP TRANSITION — shirt flies from grid to product
     Handled entirely in CSS: ps-transitions.css opts into
     cross-document view transitions (@view-transition
     { navigation: auto }) and the grid + product gallery
     images carry matching view-transition-name values.
     Browsers without support just navigate normally.
     Intercepting the click with document.startViewTransition
     here would be wrong — that API only animates
     same-document changes and merely delayed the navigation.
  ---------------------------------------------------------- */


  /* --------------------------------------------------------
     2. SIZE SELECTOR — Yeezy-style "+" expander
     The visible radios are UI-only. When a size is picked,
     we forward the click to Dawn's hidden <variant-selects>
     so its existing logic updates the variant ID, price,
     availability, etc. This preserves all Shopify mechanics.
  ---------------------------------------------------------- */

  function initSizeSelector() {
    var wrapper = document.querySelector('.ps-size-selector');
    if (!wrapper) return;

    var trigger = wrapper.querySelector('.ps-size-selector__trigger');
    var panel   = wrapper.querySelector('.ps-size-selector__panel');
    var labels  = wrapper.querySelectorAll('.ps-size-selector__options label');
    var inputs  = wrapper.querySelectorAll('.ps-size-selector__options input[type="radio"]');
    var addBtn  = document.querySelector('.ps-add-to-cart');
    var isOpen  = false;

    if (!trigger || !panel) return;

    function openPanel() {
      isOpen = true;
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');

      labels.forEach(function (label, i) {
        label.style.transitionDelay = (i * 0.055) + 's';
        label.getBoundingClientRect();
        label.classList.add('is-visible');
      });
    }

    function closePanel() {
      isOpen = false;
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');

      labels.forEach(function (label) {
        label.style.transitionDelay = '0s';
        label.classList.remove('is-visible');
      });

      /* The size-chart ("?") expander resets with the panel so every
         reopen starts collapsed instead of remembering its last state. */
      var infoTrigger = wrapper.querySelector('.ps-info__trigger');
      var infoPanel   = wrapper.querySelector('.ps-info__panel');
      if (infoTrigger) infoTrigger.setAttribute('aria-expanded', 'false');
      if (infoPanel)   infoPanel.setAttribute('aria-hidden', 'true');
    }

    /* Forward selection to Dawn's hidden picker so it can
       compute the matching variant and update the form.
       Dawn's product-info.js REPLACES the <variant-selects> element on
       every variant change (HTMLUpdateUtility), so the picker must be
       looked up fresh each call — a reference cached at init goes stale
       after the first selection and later picks silently stop updating
       the form's variant id. */
    function bridgeToDawn(value) {
      var dawnRoot = document.querySelector('variant-selects');
      if (!dawnRoot) return;

      var radio = dawnRoot.querySelector(
        'input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]'
      );
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var selects = dawnRoot.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var sel = selects[i];
        var hasValue = false;
        for (var j = 0; j < sel.options.length; j++) {
          if (sel.options[j].value === value) { hasValue = true; break; }
        }
        if (hasValue) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    trigger.addEventListener('click', function () {
      if (isOpen) { closePanel(); } else { openPanel(); }
    });

    function revealAddToCart() {
      if (addBtn) addBtn.classList.add('is-ready');
      /* Trigger label flips BUY NOW → CHANGE SIZE (see ps-transitions.css § trigger states). */
      wrapper.classList.add('ps-size-selector--selected');
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.disabled) return;
        bridgeToDawn(input.value);
        revealAddToCart();
      });

      /* Collapse on explicit activation (label tap / Space) — NOT on
         change, which also fires per arrow-key step while a keyboard
         user is still browsing the radio group. Focus follows to the
         revealed button so keyboard/AT users aren't left inside the
         now-hidden panel. */
      input.addEventListener('click', function () {
        if (input.disabled || !input.checked) return;
        revealAddToCart();
        closePanel();
        /* Deferred: at this instant the button's visibility transition is
           still at t=0 (computed: hidden), so a synchronous focus() is
           silently ignored. */
        if (addBtn) {
          window.setTimeout(function () { addBtn.focus(); }, 60);
        }
      });
    });

    /* Honor pre-selection from URL (?variant=...): if a
       radio was rendered as :checked, reveal the button. */
    var preSelected = wrapper.querySelector('input[type="radio"]:checked');
    if (preSelected && !preSelected.disabled && addBtn) {
      addBtn.classList.add('is-ready');
      wrapper.classList.add('ps-size-selector--selected');
    }

    document.addEventListener('click', function (e) {
      if (isOpen && !wrapper.contains(e.target)) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
        closePanel();
        trigger.focus();
      }
    });
  }


  /* --------------------------------------------------------
     3. SIZE GUIDE EXPANDER — text toggle below sizes
  ---------------------------------------------------------- */

  function initInfoToggle() {
    var triggers = document.querySelectorAll('.ps-info__trigger');
    triggers.forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.setAttribute('aria-hidden', open ? 'true' : 'false');
      });
    });
  }


  /* --------------------------------------------------------
     4. SIZE CHART UNITS — IN / CM toggle
     Both units are rendered; .ps-chart[data-unit] shows one.
     The choice is remembered per browser (a convenience only:
     storage can be blocked, so every access is guarded and the
     chart falls back to inches).
  ---------------------------------------------------------- */

  var UNIT_KEY = 'ps-size-unit';

  function initUnitToggle() {
    var charts = document.querySelectorAll('.ps-chart');
    if (!charts.length) return;

    function setUnit(unit) {
      charts.forEach(function (chart) {
        chart.setAttribute('data-unit', unit);
        chart.querySelectorAll('.ps-chart__unit').forEach(function (btn) {
          btn.setAttribute('aria-pressed', btn.getAttribute('data-unit') === unit ? 'true' : 'false');
        });
      });
    }

    var saved = null;
    try { saved = window.localStorage.getItem(UNIT_KEY); } catch (e) {}
    if (saved === 'cm' || saved === 'in') setUnit(saved);

    charts.forEach(function (chart) {
      chart.querySelectorAll('.ps-chart__unit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var unit = btn.getAttribute('data-unit');
          setUnit(unit);
          try { window.localStorage.setItem(UNIT_KEY, unit); } catch (e) {}
        });
      });
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSizeSelector();
      initInfoToggle();
      initUnitToggle();
    });
  } else {
    initSizeSelector();
    initInfoToggle();
    initUnitToggle();
  }
})();
